/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as TermsAndConditionsRouteImport } from './routes/terms-and-conditions'
import { Route as TcauthRouteImport } from './routes/tcauth'
import { Route as SignUpContinueRouteImport } from './routes/sign-up-continue'
import { Route as SignUpRouteImport } from './routes/sign-up'
import { Route as ResetPasswordSuccessRouteImport } from './routes/reset-password-success'
import { Route as ResetPasswordMessageRouteImport } from './routes/reset-password-message'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as ResetRouteImport } from './routes/reset'
import { Route as RaauthRouteImport } from './routes/raauth'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ConfirmRouteImport } from './routes/confirm'
import { Route as AuthBasicRouteImport } from './routes/_auth-basic'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthStatementsRouteImport } from './routes/_auth/statements'
import { Route as AuthSettingsRouteImport } from './routes/_auth/settings'
import { Route as AuthSecuritySuccessRouteImport } from './routes/_auth/security-success'
import { Route as AuthSecurityFailedRouteImport } from './routes/_auth/security-failed'
import { Route as AuthRoyaltiesRouteImport } from './routes/_auth/royalties'
import { Route as AuthFaqRouteImport } from './routes/_auth/faq'
import { Route as AuthError404RouteImport } from './routes/_auth/error-404'
import { Route as AuthBasicOnboarding3RouteImport } from './routes/_auth-basic/onboarding-3'
import { Route as AuthBasicOnboarding2RouteImport } from './routes/_auth-basic/onboarding-2'
import { Route as AuthBasicOnboarding1RouteImport } from './routes/_auth-basic/onboarding-1'
import { Route as AuthBasicOnboardingRouteImport } from './routes/_auth-basic/onboarding'
import { Route as AuthBasicAddTwitterRouteImport } from './routes/_auth-basic/add-twitter'
import { Route as AuthBasicAddSongkickRouteImport } from './routes/_auth-basic/add-songkick'
import { Route as AuthBasicAddInstagramRouteImport } from './routes/_auth-basic/add-instagram'
import { Route as AuthBasicAddFacebookRouteImport } from './routes/_auth-basic/add-facebook'
import { Route as AuthBasicAddBandsintownRouteImport } from './routes/_auth-basic/add-bandsintown'
import { Route as AuthBasicAddAccountPreRouteImport } from './routes/_auth-basic/add-account-pre'
import { Route as AuthBasicAddAccountFinalRouteImport } from './routes/_auth-basic/add-account-final'
import { Route as AuthBasicAddAccount6RouteImport } from './routes/_auth-basic/add-account-6'
import { Route as AuthBasicAddAccount5RouteImport } from './routes/_auth-basic/add-account-5'
import { Route as AuthBasicAddAccount4RouteImport } from './routes/_auth-basic/add-account-4'
import { Route as AuthBasicAddAccount3RouteImport } from './routes/_auth-basic/add-account-3'
import { Route as AuthBasicAddAccount2RouteImport } from './routes/_auth-basic/add-account-2'
import { Route as AuthBasicAddAccount1RouteImport } from './routes/_auth-basic/add-account-1'
import { Route as AuthWritersIndexRouteImport } from './routes/_auth/writers/index'
import { Route as AuthSyncsIndexRouteImport } from './routes/_auth/syncs/index'
import { Route as AuthSongsIndexRouteImport } from './routes/_auth/songs/index'
import { Route as AuthSecurityIndexRouteImport } from './routes/_auth/security/index'
import { Route as AuthOpportunitiesIndexRouteImport } from './routes/_auth/opportunities/index'
import { Route as AuthGigsIndexRouteImport } from './routes/_auth/gigs/index'
import { Route as AuthBroadcastsIndexRouteImport } from './routes/_auth/broadcasts/index'
import { Route as AuthWritersCreateRouteImport } from './routes/_auth/writers/create'
import { Route as AuthSongsCreatePlaylistRouteImport } from './routes/_auth/songs/create-playlist'
import { Route as AuthSongsCreateAlbumRouteImport } from './routes/_auth/songs/create-album'
import { Route as AuthSongsCreateRouteImport } from './routes/_auth/songs/create'
import { Route as AuthSecurityBeginSecurityCheckRouteImport } from './routes/_auth/security/begin-security-check'
import { Route as AuthSyncsApplyIndexRouteImport } from './routes/_auth/syncs/apply/index'
import { Route as AuthOpportunitiesApplyIndexRouteImport } from './routes/_auth/opportunities/apply/index'
import { Route as AuthGigsSetlistsIndexRouteImport } from './routes/_auth/gigs/setlists/index'
import { Route as AuthGigsClaimIndexRouteImport } from './routes/_auth/gigs/claim/index'
import { Route as AuthBroadcastsAddIndexRouteImport } from './routes/_auth/broadcasts/add/index'
import { Route as AuthWritersUpdateIdRouteImport } from './routes/_auth/writers/update.$id'
import { Route as AuthSyncsApplySyncIdRouteImport } from './routes/_auth/syncs/apply/$syncId'
import { Route as AuthSongsUpdateIdRouteImport } from './routes/_auth/songs/update.$id'
import { Route as AuthOpportunitiesApplyOpportunityIdRouteImport } from './routes/_auth/opportunities/apply/$opportunityId'
import { Route as AuthGigsSetlistsCreateRouteImport } from './routes/_auth/gigs/setlists/create'
import { Route as AuthBroadcastsAddBroadcastIdRouteImport } from './routes/_auth/broadcasts/add/$broadcastId'
import { Route as AuthGigsSetlistsUpdateIdRouteImport } from './routes/_auth/gigs/setlists/update.$id'
import { Route as AuthGigsClaimUpdateIdRouteImport } from './routes/_auth/gigs/claim/update.$id'

const WelcomeRoute = WelcomeRouteImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRouteImport,
} as any)
const TermsAndConditionsRoute = TermsAndConditionsRouteImport.update({
  id: '/terms-and-conditions',
  path: '/terms-and-conditions',
  getParentRoute: () => rootRouteImport,
} as any)
const TcauthRoute = TcauthRouteImport.update({
  id: '/tcauth',
  path: '/tcauth',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpContinueRoute = SignUpContinueRouteImport.update({
  id: '/sign-up-continue',
  path: '/sign-up-continue',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordSuccessRoute = ResetPasswordSuccessRouteImport.update({
  id: '/reset-password-success',
  path: '/reset-password-success',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordMessageRoute = ResetPasswordMessageRouteImport.update({
  id: '/reset-password-message',
  path: '/reset-password-message',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetRoute = ResetRouteImport.update({
  id: '/reset',
  path: '/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const RaauthRoute = RaauthRouteImport.update({
  id: '/raauth',
  path: '/raauth',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
  id: '/privacy-policy',
  path: '/privacy-policy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfirmRoute = ConfirmRouteImport.update({
  id: '/confirm',
  path: '/confirm',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthBasicRoute = AuthBasicRouteImport.update({
  id: '/_auth-basic',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthStatementsRoute = AuthStatementsRouteImport.update({
  id: '/statements',
  path: '/statements',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsRoute = AuthSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSecuritySuccessRoute = AuthSecuritySuccessRouteImport.update({
  id: '/security-success',
  path: '/security-success',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSecurityFailedRoute = AuthSecurityFailedRouteImport.update({
  id: '/security-failed',
  path: '/security-failed',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRoyaltiesRoute = AuthRoyaltiesRouteImport.update({
  id: '/royalties',
  path: '/royalties',
  getParentRoute: () => AuthRoute,
} as any)
const AuthFaqRoute = AuthFaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => AuthRoute,
} as any)
const AuthError404Route = AuthError404RouteImport.update({
  id: '/error-404',
  path: '/error-404',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBasicOnboarding3Route = AuthBasicOnboarding3RouteImport.update({
  id: '/onboarding-3',
  path: '/onboarding-3',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicOnboarding2Route = AuthBasicOnboarding2RouteImport.update({
  id: '/onboarding-2',
  path: '/onboarding-2',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicOnboarding1Route = AuthBasicOnboarding1RouteImport.update({
  id: '/onboarding-1',
  path: '/onboarding-1',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicOnboardingRoute = AuthBasicOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddTwitterRoute = AuthBasicAddTwitterRouteImport.update({
  id: '/add-twitter',
  path: '/add-twitter',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddSongkickRoute = AuthBasicAddSongkickRouteImport.update({
  id: '/add-songkick',
  path: '/add-songkick',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddInstagramRoute = AuthBasicAddInstagramRouteImport.update({
  id: '/add-instagram',
  path: '/add-instagram',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddFacebookRoute = AuthBasicAddFacebookRouteImport.update({
  id: '/add-facebook',
  path: '/add-facebook',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddBandsintownRoute = AuthBasicAddBandsintownRouteImport.update({
  id: '/add-bandsintown',
  path: '/add-bandsintown',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddAccountPreRoute = AuthBasicAddAccountPreRouteImport.update({
  id: '/add-account-pre',
  path: '/add-account-pre',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddAccountFinalRoute =
  AuthBasicAddAccountFinalRouteImport.update({
    id: '/add-account-final',
    path: '/add-account-final',
    getParentRoute: () => AuthBasicRoute,
  } as any)
const AuthBasicAddAccount6Route = AuthBasicAddAccount6RouteImport.update({
  id: '/add-account-6',
  path: '/add-account-6',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddAccount5Route = AuthBasicAddAccount5RouteImport.update({
  id: '/add-account-5',
  path: '/add-account-5',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddAccount4Route = AuthBasicAddAccount4RouteImport.update({
  id: '/add-account-4',
  path: '/add-account-4',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddAccount3Route = AuthBasicAddAccount3RouteImport.update({
  id: '/add-account-3',
  path: '/add-account-3',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddAccount2Route = AuthBasicAddAccount2RouteImport.update({
  id: '/add-account-2',
  path: '/add-account-2',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthBasicAddAccount1Route = AuthBasicAddAccount1RouteImport.update({
  id: '/add-account-1',
  path: '/add-account-1',
  getParentRoute: () => AuthBasicRoute,
} as any)
const AuthWritersIndexRoute = AuthWritersIndexRouteImport.update({
  id: '/writers/',
  path: '/writers/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSyncsIndexRoute = AuthSyncsIndexRouteImport.update({
  id: '/syncs/',
  path: '/syncs/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSongsIndexRoute = AuthSongsIndexRouteImport.update({
  id: '/songs/',
  path: '/songs/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSecurityIndexRoute = AuthSecurityIndexRouteImport.update({
  id: '/security/',
  path: '/security/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOpportunitiesIndexRoute = AuthOpportunitiesIndexRouteImport.update({
  id: '/opportunities/',
  path: '/opportunities/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGigsIndexRoute = AuthGigsIndexRouteImport.update({
  id: '/gigs/',
  path: '/gigs/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBroadcastsIndexRoute = AuthBroadcastsIndexRouteImport.update({
  id: '/broadcasts/',
  path: '/broadcasts/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWritersCreateRoute = AuthWritersCreateRouteImport.update({
  id: '/writers/create',
  path: '/writers/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSongsCreatePlaylistRoute = AuthSongsCreatePlaylistRouteImport.update({
  id: '/songs/create-playlist',
  path: '/songs/create-playlist',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSongsCreateAlbumRoute = AuthSongsCreateAlbumRouteImport.update({
  id: '/songs/create-album',
  path: '/songs/create-album',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSongsCreateRoute = AuthSongsCreateRouteImport.update({
  id: '/songs/create',
  path: '/songs/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSecurityBeginSecurityCheckRoute =
  AuthSecurityBeginSecurityCheckRouteImport.update({
    id: '/security/begin-security-check',
    path: '/security/begin-security-check',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthSyncsApplyIndexRoute = AuthSyncsApplyIndexRouteImport.update({
  id: '/syncs/apply/',
  path: '/syncs/apply/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOpportunitiesApplyIndexRoute =
  AuthOpportunitiesApplyIndexRouteImport.update({
    id: '/opportunities/apply/',
    path: '/opportunities/apply/',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGigsSetlistsIndexRoute = AuthGigsSetlistsIndexRouteImport.update({
  id: '/gigs/setlists/',
  path: '/gigs/setlists/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthGigsClaimIndexRoute = AuthGigsClaimIndexRouteImport.update({
  id: '/gigs/claim/',
  path: '/gigs/claim/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBroadcastsAddIndexRoute = AuthBroadcastsAddIndexRouteImport.update({
  id: '/broadcasts/add/',
  path: '/broadcasts/add/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthWritersUpdateIdRoute = AuthWritersUpdateIdRouteImport.update({
  id: '/writers/update/$id',
  path: '/writers/update/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSyncsApplySyncIdRoute = AuthSyncsApplySyncIdRouteImport.update({
  id: '/syncs/apply/$syncId',
  path: '/syncs/apply/$syncId',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSongsUpdateIdRoute = AuthSongsUpdateIdRouteImport.update({
  id: '/songs/update/$id',
  path: '/songs/update/$id',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOpportunitiesApplyOpportunityIdRoute =
  AuthOpportunitiesApplyOpportunityIdRouteImport.update({
    id: '/opportunities/apply/$opportunityId',
    path: '/opportunities/apply/$opportunityId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGigsSetlistsCreateRoute = AuthGigsSetlistsCreateRouteImport.update({
  id: '/gigs/setlists/create',
  path: '/gigs/setlists/create',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBroadcastsAddBroadcastIdRoute =
  AuthBroadcastsAddBroadcastIdRouteImport.update({
    id: '/broadcasts/add/$broadcastId',
    path: '/broadcasts/add/$broadcastId',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGigsSetlistsUpdateIdRoute =
  AuthGigsSetlistsUpdateIdRouteImport.update({
    id: '/gigs/setlists/update/$id',
    path: '/gigs/setlists/update/$id',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthGigsClaimUpdateIdRoute = AuthGigsClaimUpdateIdRouteImport.update({
  id: '/gigs/claim/update/$id',
  path: '/gigs/claim/update/$id',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/confirm': typeof ConfirmRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/raauth': typeof RaauthRoute
  '/reset': typeof ResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-message': typeof ResetPasswordMessageRoute
  '/reset-password-success': typeof ResetPasswordSuccessRoute
  '/sign-up': typeof SignUpRoute
  '/sign-up-continue': typeof SignUpContinueRoute
  '/tcauth': typeof TcauthRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/welcome': typeof WelcomeRoute
  '/add-account-1': typeof AuthBasicAddAccount1Route
  '/add-account-2': typeof AuthBasicAddAccount2Route
  '/add-account-3': typeof AuthBasicAddAccount3Route
  '/add-account-4': typeof AuthBasicAddAccount4Route
  '/add-account-5': typeof AuthBasicAddAccount5Route
  '/add-account-6': typeof AuthBasicAddAccount6Route
  '/add-account-final': typeof AuthBasicAddAccountFinalRoute
  '/add-account-pre': typeof AuthBasicAddAccountPreRoute
  '/add-bandsintown': typeof AuthBasicAddBandsintownRoute
  '/add-facebook': typeof AuthBasicAddFacebookRoute
  '/add-instagram': typeof AuthBasicAddInstagramRoute
  '/add-songkick': typeof AuthBasicAddSongkickRoute
  '/add-twitter': typeof AuthBasicAddTwitterRoute
  '/onboarding': typeof AuthBasicOnboardingRoute
  '/onboarding-1': typeof AuthBasicOnboarding1Route
  '/onboarding-2': typeof AuthBasicOnboarding2Route
  '/onboarding-3': typeof AuthBasicOnboarding3Route
  '/error-404': typeof AuthError404Route
  '/faq': typeof AuthFaqRoute
  '/royalties': typeof AuthRoyaltiesRoute
  '/security-failed': typeof AuthSecurityFailedRoute
  '/security-success': typeof AuthSecuritySuccessRoute
  '/settings': typeof AuthSettingsRoute
  '/statements': typeof AuthStatementsRoute
  '/security/begin-security-check': typeof AuthSecurityBeginSecurityCheckRoute
  '/songs/create': typeof AuthSongsCreateRoute
  '/songs/create-album': typeof AuthSongsCreateAlbumRoute
  '/songs/create-playlist': typeof AuthSongsCreatePlaylistRoute
  '/writers/create': typeof AuthWritersCreateRoute
  '/broadcasts/': typeof AuthBroadcastsIndexRoute
  '/gigs/': typeof AuthGigsIndexRoute
  '/opportunities/': typeof AuthOpportunitiesIndexRoute
  '/security/': typeof AuthSecurityIndexRoute
  '/songs/': typeof AuthSongsIndexRoute
  '/syncs/': typeof AuthSyncsIndexRoute
  '/writers/': typeof AuthWritersIndexRoute
  '/broadcasts/add/$broadcastId': typeof AuthBroadcastsAddBroadcastIdRoute
  '/gigs/setlists/create': typeof AuthGigsSetlistsCreateRoute
  '/opportunities/apply/$opportunityId': typeof AuthOpportunitiesApplyOpportunityIdRoute
  '/songs/update/$id': typeof AuthSongsUpdateIdRoute
  '/syncs/apply/$syncId': typeof AuthSyncsApplySyncIdRoute
  '/writers/update/$id': typeof AuthWritersUpdateIdRoute
  '/broadcasts/add/': typeof AuthBroadcastsAddIndexRoute
  '/gigs/claim/': typeof AuthGigsClaimIndexRoute
  '/gigs/setlists/': typeof AuthGigsSetlistsIndexRoute
  '/opportunities/apply/': typeof AuthOpportunitiesApplyIndexRoute
  '/syncs/apply/': typeof AuthSyncsApplyIndexRoute
  '/gigs/claim/update/$id': typeof AuthGigsClaimUpdateIdRoute
  '/gigs/setlists/update/$id': typeof AuthGigsSetlistsUpdateIdRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexRoute
  '/confirm': typeof ConfirmRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/raauth': typeof RaauthRoute
  '/reset': typeof ResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-message': typeof ResetPasswordMessageRoute
  '/reset-password-success': typeof ResetPasswordSuccessRoute
  '/sign-up': typeof SignUpRoute
  '/sign-up-continue': typeof SignUpContinueRoute
  '/tcauth': typeof TcauthRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/welcome': typeof WelcomeRoute
  '/add-account-1': typeof AuthBasicAddAccount1Route
  '/add-account-2': typeof AuthBasicAddAccount2Route
  '/add-account-3': typeof AuthBasicAddAccount3Route
  '/add-account-4': typeof AuthBasicAddAccount4Route
  '/add-account-5': typeof AuthBasicAddAccount5Route
  '/add-account-6': typeof AuthBasicAddAccount6Route
  '/add-account-final': typeof AuthBasicAddAccountFinalRoute
  '/add-account-pre': typeof AuthBasicAddAccountPreRoute
  '/add-bandsintown': typeof AuthBasicAddBandsintownRoute
  '/add-facebook': typeof AuthBasicAddFacebookRoute
  '/add-instagram': typeof AuthBasicAddInstagramRoute
  '/add-songkick': typeof AuthBasicAddSongkickRoute
  '/add-twitter': typeof AuthBasicAddTwitterRoute
  '/onboarding': typeof AuthBasicOnboardingRoute
  '/onboarding-1': typeof AuthBasicOnboarding1Route
  '/onboarding-2': typeof AuthBasicOnboarding2Route
  '/onboarding-3': typeof AuthBasicOnboarding3Route
  '/error-404': typeof AuthError404Route
  '/faq': typeof AuthFaqRoute
  '/royalties': typeof AuthRoyaltiesRoute
  '/security-failed': typeof AuthSecurityFailedRoute
  '/security-success': typeof AuthSecuritySuccessRoute
  '/settings': typeof AuthSettingsRoute
  '/statements': typeof AuthStatementsRoute
  '/security/begin-security-check': typeof AuthSecurityBeginSecurityCheckRoute
  '/songs/create': typeof AuthSongsCreateRoute
  '/songs/create-album': typeof AuthSongsCreateAlbumRoute
  '/songs/create-playlist': typeof AuthSongsCreatePlaylistRoute
  '/writers/create': typeof AuthWritersCreateRoute
  '/broadcasts': typeof AuthBroadcastsIndexRoute
  '/gigs': typeof AuthGigsIndexRoute
  '/opportunities': typeof AuthOpportunitiesIndexRoute
  '/security': typeof AuthSecurityIndexRoute
  '/songs': typeof AuthSongsIndexRoute
  '/syncs': typeof AuthSyncsIndexRoute
  '/writers': typeof AuthWritersIndexRoute
  '/broadcasts/add/$broadcastId': typeof AuthBroadcastsAddBroadcastIdRoute
  '/gigs/setlists/create': typeof AuthGigsSetlistsCreateRoute
  '/opportunities/apply/$opportunityId': typeof AuthOpportunitiesApplyOpportunityIdRoute
  '/songs/update/$id': typeof AuthSongsUpdateIdRoute
  '/syncs/apply/$syncId': typeof AuthSyncsApplySyncIdRoute
  '/writers/update/$id': typeof AuthWritersUpdateIdRoute
  '/broadcasts/add': typeof AuthBroadcastsAddIndexRoute
  '/gigs/claim': typeof AuthGigsClaimIndexRoute
  '/gigs/setlists': typeof AuthGigsSetlistsIndexRoute
  '/opportunities/apply': typeof AuthOpportunitiesApplyIndexRoute
  '/syncs/apply': typeof AuthSyncsApplyIndexRoute
  '/gigs/claim/update/$id': typeof AuthGigsClaimUpdateIdRoute
  '/gigs/setlists/update/$id': typeof AuthGigsSetlistsUpdateIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_auth-basic': typeof AuthBasicRouteWithChildren
  '/confirm': typeof ConfirmRoute
  '/login': typeof LoginRoute
  '/privacy-policy': typeof PrivacyPolicyRoute
  '/raauth': typeof RaauthRoute
  '/reset': typeof ResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/reset-password-message': typeof ResetPasswordMessageRoute
  '/reset-password-success': typeof ResetPasswordSuccessRoute
  '/sign-up': typeof SignUpRoute
  '/sign-up-continue': typeof SignUpContinueRoute
  '/tcauth': typeof TcauthRoute
  '/terms-and-conditions': typeof TermsAndConditionsRoute
  '/welcome': typeof WelcomeRoute
  '/_auth-basic/add-account-1': typeof AuthBasicAddAccount1Route
  '/_auth-basic/add-account-2': typeof AuthBasicAddAccount2Route
  '/_auth-basic/add-account-3': typeof AuthBasicAddAccount3Route
  '/_auth-basic/add-account-4': typeof AuthBasicAddAccount4Route
  '/_auth-basic/add-account-5': typeof AuthBasicAddAccount5Route
  '/_auth-basic/add-account-6': typeof AuthBasicAddAccount6Route
  '/_auth-basic/add-account-final': typeof AuthBasicAddAccountFinalRoute
  '/_auth-basic/add-account-pre': typeof AuthBasicAddAccountPreRoute
  '/_auth-basic/add-bandsintown': typeof AuthBasicAddBandsintownRoute
  '/_auth-basic/add-facebook': typeof AuthBasicAddFacebookRoute
  '/_auth-basic/add-instagram': typeof AuthBasicAddInstagramRoute
  '/_auth-basic/add-songkick': typeof AuthBasicAddSongkickRoute
  '/_auth-basic/add-twitter': typeof AuthBasicAddTwitterRoute
  '/_auth-basic/onboarding': typeof AuthBasicOnboardingRoute
  '/_auth-basic/onboarding-1': typeof AuthBasicOnboarding1Route
  '/_auth-basic/onboarding-2': typeof AuthBasicOnboarding2Route
  '/_auth-basic/onboarding-3': typeof AuthBasicOnboarding3Route
  '/_auth/error-404': typeof AuthError404Route
  '/_auth/faq': typeof AuthFaqRoute
  '/_auth/royalties': typeof AuthRoyaltiesRoute
  '/_auth/security-failed': typeof AuthSecurityFailedRoute
  '/_auth/security-success': typeof AuthSecuritySuccessRoute
  '/_auth/settings': typeof AuthSettingsRoute
  '/_auth/statements': typeof AuthStatementsRoute
  '/_auth/': typeof AuthIndexRoute
  '/_auth/security/begin-security-check': typeof AuthSecurityBeginSecurityCheckRoute
  '/_auth/songs/create': typeof AuthSongsCreateRoute
  '/_auth/songs/create-album': typeof AuthSongsCreateAlbumRoute
  '/_auth/songs/create-playlist': typeof AuthSongsCreatePlaylistRoute
  '/_auth/writers/create': typeof AuthWritersCreateRoute
  '/_auth/broadcasts/': typeof AuthBroadcastsIndexRoute
  '/_auth/gigs/': typeof AuthGigsIndexRoute
  '/_auth/opportunities/': typeof AuthOpportunitiesIndexRoute
  '/_auth/security/': typeof AuthSecurityIndexRoute
  '/_auth/songs/': typeof AuthSongsIndexRoute
  '/_auth/syncs/': typeof AuthSyncsIndexRoute
  '/_auth/writers/': typeof AuthWritersIndexRoute
  '/_auth/broadcasts/add/$broadcastId': typeof AuthBroadcastsAddBroadcastIdRoute
  '/_auth/gigs/setlists/create': typeof AuthGigsSetlistsCreateRoute
  '/_auth/opportunities/apply/$opportunityId': typeof AuthOpportunitiesApplyOpportunityIdRoute
  '/_auth/songs/update/$id': typeof AuthSongsUpdateIdRoute
  '/_auth/syncs/apply/$syncId': typeof AuthSyncsApplySyncIdRoute
  '/_auth/writers/update/$id': typeof AuthWritersUpdateIdRoute
  '/_auth/broadcasts/add/': typeof AuthBroadcastsAddIndexRoute
  '/_auth/gigs/claim/': typeof AuthGigsClaimIndexRoute
  '/_auth/gigs/setlists/': typeof AuthGigsSetlistsIndexRoute
  '/_auth/opportunities/apply/': typeof AuthOpportunitiesApplyIndexRoute
  '/_auth/syncs/apply/': typeof AuthSyncsApplyIndexRoute
  '/_auth/gigs/claim/update/$id': typeof AuthGigsClaimUpdateIdRoute
  '/_auth/gigs/setlists/update/$id': typeof AuthGigsSetlistsUpdateIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/confirm'
    | '/login'
    | '/privacy-policy'
    | '/raauth'
    | '/reset'
    | '/reset-password'
    | '/reset-password-message'
    | '/reset-password-success'
    | '/sign-up'
    | '/sign-up-continue'
    | '/tcauth'
    | '/terms-and-conditions'
    | '/welcome'
    | '/add-account-1'
    | '/add-account-2'
    | '/add-account-3'
    | '/add-account-4'
    | '/add-account-5'
    | '/add-account-6'
    | '/add-account-final'
    | '/add-account-pre'
    | '/add-bandsintown'
    | '/add-facebook'
    | '/add-instagram'
    | '/add-songkick'
    | '/add-twitter'
    | '/onboarding'
    | '/onboarding-1'
    | '/onboarding-2'
    | '/onboarding-3'
    | '/error-404'
    | '/faq'
    | '/royalties'
    | '/security-failed'
    | '/security-success'
    | '/settings'
    | '/statements'
    | '/security/begin-security-check'
    | '/songs/create'
    | '/songs/create-album'
    | '/songs/create-playlist'
    | '/writers/create'
    | '/broadcasts/'
    | '/gigs/'
    | '/opportunities/'
    | '/security/'
    | '/songs/'
    | '/syncs/'
    | '/writers/'
    | '/broadcasts/add/$broadcastId'
    | '/gigs/setlists/create'
    | '/opportunities/apply/$opportunityId'
    | '/songs/update/$id'
    | '/syncs/apply/$syncId'
    | '/writers/update/$id'
    | '/broadcasts/add/'
    | '/gigs/claim/'
    | '/gigs/setlists/'
    | '/opportunities/apply/'
    | '/syncs/apply/'
    | '/gigs/claim/update/$id'
    | '/gigs/setlists/update/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/confirm'
    | '/login'
    | '/privacy-policy'
    | '/raauth'
    | '/reset'
    | '/reset-password'
    | '/reset-password-message'
    | '/reset-password-success'
    | '/sign-up'
    | '/sign-up-continue'
    | '/tcauth'
    | '/terms-and-conditions'
    | '/welcome'
    | '/add-account-1'
    | '/add-account-2'
    | '/add-account-3'
    | '/add-account-4'
    | '/add-account-5'
    | '/add-account-6'
    | '/add-account-final'
    | '/add-account-pre'
    | '/add-bandsintown'
    | '/add-facebook'
    | '/add-instagram'
    | '/add-songkick'
    | '/add-twitter'
    | '/onboarding'
    | '/onboarding-1'
    | '/onboarding-2'
    | '/onboarding-3'
    | '/error-404'
    | '/faq'
    | '/royalties'
    | '/security-failed'
    | '/security-success'
    | '/settings'
    | '/statements'
    | '/security/begin-security-check'
    | '/songs/create'
    | '/songs/create-album'
    | '/songs/create-playlist'
    | '/writers/create'
    | '/broadcasts'
    | '/gigs'
    | '/opportunities'
    | '/security'
    | '/songs'
    | '/syncs'
    | '/writers'
    | '/broadcasts/add/$broadcastId'
    | '/gigs/setlists/create'
    | '/opportunities/apply/$opportunityId'
    | '/songs/update/$id'
    | '/syncs/apply/$syncId'
    | '/writers/update/$id'
    | '/broadcasts/add'
    | '/gigs/claim'
    | '/gigs/setlists'
    | '/opportunities/apply'
    | '/syncs/apply'
    | '/gigs/claim/update/$id'
    | '/gigs/setlists/update/$id'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth-basic'
    | '/confirm'
    | '/login'
    | '/privacy-policy'
    | '/raauth'
    | '/reset'
    | '/reset-password'
    | '/reset-password-message'
    | '/reset-password-success'
    | '/sign-up'
    | '/sign-up-continue'
    | '/tcauth'
    | '/terms-and-conditions'
    | '/welcome'
    | '/_auth-basic/add-account-1'
    | '/_auth-basic/add-account-2'
    | '/_auth-basic/add-account-3'
    | '/_auth-basic/add-account-4'
    | '/_auth-basic/add-account-5'
    | '/_auth-basic/add-account-6'
    | '/_auth-basic/add-account-final'
    | '/_auth-basic/add-account-pre'
    | '/_auth-basic/add-bandsintown'
    | '/_auth-basic/add-facebook'
    | '/_auth-basic/add-instagram'
    | '/_auth-basic/add-songkick'
    | '/_auth-basic/add-twitter'
    | '/_auth-basic/onboarding'
    | '/_auth-basic/onboarding-1'
    | '/_auth-basic/onboarding-2'
    | '/_auth-basic/onboarding-3'
    | '/_auth/error-404'
    | '/_auth/faq'
    | '/_auth/royalties'
    | '/_auth/security-failed'
    | '/_auth/security-success'
    | '/_auth/settings'
    | '/_auth/statements'
    | '/_auth/'
    | '/_auth/security/begin-security-check'
    | '/_auth/songs/create'
    | '/_auth/songs/create-album'
    | '/_auth/songs/create-playlist'
    | '/_auth/writers/create'
    | '/_auth/broadcasts/'
    | '/_auth/gigs/'
    | '/_auth/opportunities/'
    | '/_auth/security/'
    | '/_auth/songs/'
    | '/_auth/syncs/'
    | '/_auth/writers/'
    | '/_auth/broadcasts/add/$broadcastId'
    | '/_auth/gigs/setlists/create'
    | '/_auth/opportunities/apply/$opportunityId'
    | '/_auth/songs/update/$id'
    | '/_auth/syncs/apply/$syncId'
    | '/_auth/writers/update/$id'
    | '/_auth/broadcasts/add/'
    | '/_auth/gigs/claim/'
    | '/_auth/gigs/setlists/'
    | '/_auth/opportunities/apply/'
    | '/_auth/syncs/apply/'
    | '/_auth/gigs/claim/update/$id'
    | '/_auth/gigs/setlists/update/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AuthBasicRoute: typeof AuthBasicRouteWithChildren
  ConfirmRoute: typeof ConfirmRoute
  LoginRoute: typeof LoginRoute
  PrivacyPolicyRoute: typeof PrivacyPolicyRoute
  RaauthRoute: typeof RaauthRoute
  ResetRoute: typeof ResetRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  ResetPasswordMessageRoute: typeof ResetPasswordMessageRoute
  ResetPasswordSuccessRoute: typeof ResetPasswordSuccessRoute
  SignUpRoute: typeof SignUpRoute
  SignUpContinueRoute: typeof SignUpContinueRoute
  TcauthRoute: typeof TcauthRoute
  TermsAndConditionsRoute: typeof TermsAndConditionsRoute
  WelcomeRoute: typeof WelcomeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/terms-and-conditions': {
      id: '/terms-and-conditions'
      path: '/terms-and-conditions'
      fullPath: '/terms-and-conditions'
      preLoaderRoute: typeof TermsAndConditionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tcauth': {
      id: '/tcauth'
      path: '/tcauth'
      fullPath: '/tcauth'
      preLoaderRoute: typeof TcauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up-continue': {
      id: '/sign-up-continue'
      path: '/sign-up-continue'
      fullPath: '/sign-up-continue'
      preLoaderRoute: typeof SignUpContinueRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-success': {
      id: '/reset-password-success'
      path: '/reset-password-success'
      fullPath: '/reset-password-success'
      preLoaderRoute: typeof ResetPasswordSuccessRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password-message': {
      id: '/reset-password-message'
      path: '/reset-password-message'
      fullPath: '/reset-password-message'
      preLoaderRoute: typeof ResetPasswordMessageRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset': {
      id: '/reset'
      path: '/reset'
      fullPath: '/reset'
      preLoaderRoute: typeof ResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/raauth': {
      id: '/raauth'
      path: '/raauth'
      fullPath: '/raauth'
      preLoaderRoute: typeof RaauthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy-policy': {
      id: '/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PrivacyPolicyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/confirm': {
      id: '/confirm'
      path: '/confirm'
      fullPath: '/confirm'
      preLoaderRoute: typeof ConfirmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth-basic': {
      id: '/_auth-basic'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthBasicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/statements': {
      id: '/_auth/statements'
      path: '/statements'
      fullPath: '/statements'
      preLoaderRoute: typeof AuthStatementsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings': {
      id: '/_auth/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthSettingsRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/security-success': {
      id: '/_auth/security-success'
      path: '/security-success'
      fullPath: '/security-success'
      preLoaderRoute: typeof AuthSecuritySuccessRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/security-failed': {
      id: '/_auth/security-failed'
      path: '/security-failed'
      fullPath: '/security-failed'
      preLoaderRoute: typeof AuthSecurityFailedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/royalties': {
      id: '/_auth/royalties'
      path: '/royalties'
      fullPath: '/royalties'
      preLoaderRoute: typeof AuthRoyaltiesRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/faq': {
      id: '/_auth/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof AuthFaqRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/error-404': {
      id: '/_auth/error-404'
      path: '/error-404'
      fullPath: '/error-404'
      preLoaderRoute: typeof AuthError404RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth-basic/onboarding-3': {
      id: '/_auth-basic/onboarding-3'
      path: '/onboarding-3'
      fullPath: '/onboarding-3'
      preLoaderRoute: typeof AuthBasicOnboarding3RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/onboarding-2': {
      id: '/_auth-basic/onboarding-2'
      path: '/onboarding-2'
      fullPath: '/onboarding-2'
      preLoaderRoute: typeof AuthBasicOnboarding2RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/onboarding-1': {
      id: '/_auth-basic/onboarding-1'
      path: '/onboarding-1'
      fullPath: '/onboarding-1'
      preLoaderRoute: typeof AuthBasicOnboarding1RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/onboarding': {
      id: '/_auth-basic/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthBasicOnboardingRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-twitter': {
      id: '/_auth-basic/add-twitter'
      path: '/add-twitter'
      fullPath: '/add-twitter'
      preLoaderRoute: typeof AuthBasicAddTwitterRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-songkick': {
      id: '/_auth-basic/add-songkick'
      path: '/add-songkick'
      fullPath: '/add-songkick'
      preLoaderRoute: typeof AuthBasicAddSongkickRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-instagram': {
      id: '/_auth-basic/add-instagram'
      path: '/add-instagram'
      fullPath: '/add-instagram'
      preLoaderRoute: typeof AuthBasicAddInstagramRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-facebook': {
      id: '/_auth-basic/add-facebook'
      path: '/add-facebook'
      fullPath: '/add-facebook'
      preLoaderRoute: typeof AuthBasicAddFacebookRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-bandsintown': {
      id: '/_auth-basic/add-bandsintown'
      path: '/add-bandsintown'
      fullPath: '/add-bandsintown'
      preLoaderRoute: typeof AuthBasicAddBandsintownRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-pre': {
      id: '/_auth-basic/add-account-pre'
      path: '/add-account-pre'
      fullPath: '/add-account-pre'
      preLoaderRoute: typeof AuthBasicAddAccountPreRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-final': {
      id: '/_auth-basic/add-account-final'
      path: '/add-account-final'
      fullPath: '/add-account-final'
      preLoaderRoute: typeof AuthBasicAddAccountFinalRouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-6': {
      id: '/_auth-basic/add-account-6'
      path: '/add-account-6'
      fullPath: '/add-account-6'
      preLoaderRoute: typeof AuthBasicAddAccount6RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-5': {
      id: '/_auth-basic/add-account-5'
      path: '/add-account-5'
      fullPath: '/add-account-5'
      preLoaderRoute: typeof AuthBasicAddAccount5RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-4': {
      id: '/_auth-basic/add-account-4'
      path: '/add-account-4'
      fullPath: '/add-account-4'
      preLoaderRoute: typeof AuthBasicAddAccount4RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-3': {
      id: '/_auth-basic/add-account-3'
      path: '/add-account-3'
      fullPath: '/add-account-3'
      preLoaderRoute: typeof AuthBasicAddAccount3RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-2': {
      id: '/_auth-basic/add-account-2'
      path: '/add-account-2'
      fullPath: '/add-account-2'
      preLoaderRoute: typeof AuthBasicAddAccount2RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth-basic/add-account-1': {
      id: '/_auth-basic/add-account-1'
      path: '/add-account-1'
      fullPath: '/add-account-1'
      preLoaderRoute: typeof AuthBasicAddAccount1RouteImport
      parentRoute: typeof AuthBasicRoute
    }
    '/_auth/writers/': {
      id: '/_auth/writers/'
      path: '/writers'
      fullPath: '/writers/'
      preLoaderRoute: typeof AuthWritersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/syncs/': {
      id: '/_auth/syncs/'
      path: '/syncs'
      fullPath: '/syncs/'
      preLoaderRoute: typeof AuthSyncsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/songs/': {
      id: '/_auth/songs/'
      path: '/songs'
      fullPath: '/songs/'
      preLoaderRoute: typeof AuthSongsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/security/': {
      id: '/_auth/security/'
      path: '/security'
      fullPath: '/security/'
      preLoaderRoute: typeof AuthSecurityIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/opportunities/': {
      id: '/_auth/opportunities/'
      path: '/opportunities'
      fullPath: '/opportunities/'
      preLoaderRoute: typeof AuthOpportunitiesIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gigs/': {
      id: '/_auth/gigs/'
      path: '/gigs'
      fullPath: '/gigs/'
      preLoaderRoute: typeof AuthGigsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/broadcasts/': {
      id: '/_auth/broadcasts/'
      path: '/broadcasts'
      fullPath: '/broadcasts/'
      preLoaderRoute: typeof AuthBroadcastsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/writers/create': {
      id: '/_auth/writers/create'
      path: '/writers/create'
      fullPath: '/writers/create'
      preLoaderRoute: typeof AuthWritersCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/songs/create-playlist': {
      id: '/_auth/songs/create-playlist'
      path: '/songs/create-playlist'
      fullPath: '/songs/create-playlist'
      preLoaderRoute: typeof AuthSongsCreatePlaylistRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/songs/create-album': {
      id: '/_auth/songs/create-album'
      path: '/songs/create-album'
      fullPath: '/songs/create-album'
      preLoaderRoute: typeof AuthSongsCreateAlbumRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/songs/create': {
      id: '/_auth/songs/create'
      path: '/songs/create'
      fullPath: '/songs/create'
      preLoaderRoute: typeof AuthSongsCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/security/begin-security-check': {
      id: '/_auth/security/begin-security-check'
      path: '/security/begin-security-check'
      fullPath: '/security/begin-security-check'
      preLoaderRoute: typeof AuthSecurityBeginSecurityCheckRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/syncs/apply/': {
      id: '/_auth/syncs/apply/'
      path: '/syncs/apply'
      fullPath: '/syncs/apply/'
      preLoaderRoute: typeof AuthSyncsApplyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/opportunities/apply/': {
      id: '/_auth/opportunities/apply/'
      path: '/opportunities/apply'
      fullPath: '/opportunities/apply/'
      preLoaderRoute: typeof AuthOpportunitiesApplyIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gigs/setlists/': {
      id: '/_auth/gigs/setlists/'
      path: '/gigs/setlists'
      fullPath: '/gigs/setlists/'
      preLoaderRoute: typeof AuthGigsSetlistsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gigs/claim/': {
      id: '/_auth/gigs/claim/'
      path: '/gigs/claim'
      fullPath: '/gigs/claim/'
      preLoaderRoute: typeof AuthGigsClaimIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/broadcasts/add/': {
      id: '/_auth/broadcasts/add/'
      path: '/broadcasts/add'
      fullPath: '/broadcasts/add/'
      preLoaderRoute: typeof AuthBroadcastsAddIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/writers/update/$id': {
      id: '/_auth/writers/update/$id'
      path: '/writers/update/$id'
      fullPath: '/writers/update/$id'
      preLoaderRoute: typeof AuthWritersUpdateIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/syncs/apply/$syncId': {
      id: '/_auth/syncs/apply/$syncId'
      path: '/syncs/apply/$syncId'
      fullPath: '/syncs/apply/$syncId'
      preLoaderRoute: typeof AuthSyncsApplySyncIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/songs/update/$id': {
      id: '/_auth/songs/update/$id'
      path: '/songs/update/$id'
      fullPath: '/songs/update/$id'
      preLoaderRoute: typeof AuthSongsUpdateIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/opportunities/apply/$opportunityId': {
      id: '/_auth/opportunities/apply/$opportunityId'
      path: '/opportunities/apply/$opportunityId'
      fullPath: '/opportunities/apply/$opportunityId'
      preLoaderRoute: typeof AuthOpportunitiesApplyOpportunityIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gigs/setlists/create': {
      id: '/_auth/gigs/setlists/create'
      path: '/gigs/setlists/create'
      fullPath: '/gigs/setlists/create'
      preLoaderRoute: typeof AuthGigsSetlistsCreateRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/broadcasts/add/$broadcastId': {
      id: '/_auth/broadcasts/add/$broadcastId'
      path: '/broadcasts/add/$broadcastId'
      fullPath: '/broadcasts/add/$broadcastId'
      preLoaderRoute: typeof AuthBroadcastsAddBroadcastIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gigs/setlists/update/$id': {
      id: '/_auth/gigs/setlists/update/$id'
      path: '/gigs/setlists/update/$id'
      fullPath: '/gigs/setlists/update/$id'
      preLoaderRoute: typeof AuthGigsSetlistsUpdateIdRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/gigs/claim/update/$id': {
      id: '/_auth/gigs/claim/update/$id'
      path: '/gigs/claim/update/$id'
      fullPath: '/gigs/claim/update/$id'
      preLoaderRoute: typeof AuthGigsClaimUpdateIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthError404Route: typeof AuthError404Route
  AuthFaqRoute: typeof AuthFaqRoute
  AuthRoyaltiesRoute: typeof AuthRoyaltiesRoute
  AuthSecurityFailedRoute: typeof AuthSecurityFailedRoute
  AuthSecuritySuccessRoute: typeof AuthSecuritySuccessRoute
  AuthSettingsRoute: typeof AuthSettingsRoute
  AuthStatementsRoute: typeof AuthStatementsRoute
  AuthIndexRoute: typeof AuthIndexRoute
  AuthSecurityBeginSecurityCheckRoute: typeof AuthSecurityBeginSecurityCheckRoute
  AuthSongsCreateRoute: typeof AuthSongsCreateRoute
  AuthSongsCreateAlbumRoute: typeof AuthSongsCreateAlbumRoute
  AuthSongsCreatePlaylistRoute: typeof AuthSongsCreatePlaylistRoute
  AuthWritersCreateRoute: typeof AuthWritersCreateRoute
  AuthBroadcastsIndexRoute: typeof AuthBroadcastsIndexRoute
  AuthGigsIndexRoute: typeof AuthGigsIndexRoute
  AuthOpportunitiesIndexRoute: typeof AuthOpportunitiesIndexRoute
  AuthSecurityIndexRoute: typeof AuthSecurityIndexRoute
  AuthSongsIndexRoute: typeof AuthSongsIndexRoute
  AuthSyncsIndexRoute: typeof AuthSyncsIndexRoute
  AuthWritersIndexRoute: typeof AuthWritersIndexRoute
  AuthBroadcastsAddBroadcastIdRoute: typeof AuthBroadcastsAddBroadcastIdRoute
  AuthGigsSetlistsCreateRoute: typeof AuthGigsSetlistsCreateRoute
  AuthOpportunitiesApplyOpportunityIdRoute: typeof AuthOpportunitiesApplyOpportunityIdRoute
  AuthSongsUpdateIdRoute: typeof AuthSongsUpdateIdRoute
  AuthSyncsApplySyncIdRoute: typeof AuthSyncsApplySyncIdRoute
  AuthWritersUpdateIdRoute: typeof AuthWritersUpdateIdRoute
  AuthBroadcastsAddIndexRoute: typeof AuthBroadcastsAddIndexRoute
  AuthGigsClaimIndexRoute: typeof AuthGigsClaimIndexRoute
  AuthGigsSetlistsIndexRoute: typeof AuthGigsSetlistsIndexRoute
  AuthOpportunitiesApplyIndexRoute: typeof AuthOpportunitiesApplyIndexRoute
  AuthSyncsApplyIndexRoute: typeof AuthSyncsApplyIndexRoute
  AuthGigsClaimUpdateIdRoute: typeof AuthGigsClaimUpdateIdRoute
  AuthGigsSetlistsUpdateIdRoute: typeof AuthGigsSetlistsUpdateIdRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthError404Route: AuthError404Route,
  AuthFaqRoute: AuthFaqRoute,
  AuthRoyaltiesRoute: AuthRoyaltiesRoute,
  AuthSecurityFailedRoute: AuthSecurityFailedRoute,
  AuthSecuritySuccessRoute: AuthSecuritySuccessRoute,
  AuthSettingsRoute: AuthSettingsRoute,
  AuthStatementsRoute: AuthStatementsRoute,
  AuthIndexRoute: AuthIndexRoute,
  AuthSecurityBeginSecurityCheckRoute: AuthSecurityBeginSecurityCheckRoute,
  AuthSongsCreateRoute: AuthSongsCreateRoute,
  AuthSongsCreateAlbumRoute: AuthSongsCreateAlbumRoute,
  AuthSongsCreatePlaylistRoute: AuthSongsCreatePlaylistRoute,
  AuthWritersCreateRoute: AuthWritersCreateRoute,
  AuthBroadcastsIndexRoute: AuthBroadcastsIndexRoute,
  AuthGigsIndexRoute: AuthGigsIndexRoute,
  AuthOpportunitiesIndexRoute: AuthOpportunitiesIndexRoute,
  AuthSecurityIndexRoute: AuthSecurityIndexRoute,
  AuthSongsIndexRoute: AuthSongsIndexRoute,
  AuthSyncsIndexRoute: AuthSyncsIndexRoute,
  AuthWritersIndexRoute: AuthWritersIndexRoute,
  AuthBroadcastsAddBroadcastIdRoute: AuthBroadcastsAddBroadcastIdRoute,
  AuthGigsSetlistsCreateRoute: AuthGigsSetlistsCreateRoute,
  AuthOpportunitiesApplyOpportunityIdRoute:
    AuthOpportunitiesApplyOpportunityIdRoute,
  AuthSongsUpdateIdRoute: AuthSongsUpdateIdRoute,
  AuthSyncsApplySyncIdRoute: AuthSyncsApplySyncIdRoute,
  AuthWritersUpdateIdRoute: AuthWritersUpdateIdRoute,
  AuthBroadcastsAddIndexRoute: AuthBroadcastsAddIndexRoute,
  AuthGigsClaimIndexRoute: AuthGigsClaimIndexRoute,
  AuthGigsSetlistsIndexRoute: AuthGigsSetlistsIndexRoute,
  AuthOpportunitiesApplyIndexRoute: AuthOpportunitiesApplyIndexRoute,
  AuthSyncsApplyIndexRoute: AuthSyncsApplyIndexRoute,
  AuthGigsClaimUpdateIdRoute: AuthGigsClaimUpdateIdRoute,
  AuthGigsSetlistsUpdateIdRoute: AuthGigsSetlistsUpdateIdRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

interface AuthBasicRouteChildren {
  AuthBasicAddAccount1Route: typeof AuthBasicAddAccount1Route
  AuthBasicAddAccount2Route: typeof AuthBasicAddAccount2Route
  AuthBasicAddAccount3Route: typeof AuthBasicAddAccount3Route
  AuthBasicAddAccount4Route: typeof AuthBasicAddAccount4Route
  AuthBasicAddAccount5Route: typeof AuthBasicAddAccount5Route
  AuthBasicAddAccount6Route: typeof AuthBasicAddAccount6Route
  AuthBasicAddAccountFinalRoute: typeof AuthBasicAddAccountFinalRoute
  AuthBasicAddAccountPreRoute: typeof AuthBasicAddAccountPreRoute
  AuthBasicAddBandsintownRoute: typeof AuthBasicAddBandsintownRoute
  AuthBasicAddFacebookRoute: typeof AuthBasicAddFacebookRoute
  AuthBasicAddInstagramRoute: typeof AuthBasicAddInstagramRoute
  AuthBasicAddSongkickRoute: typeof AuthBasicAddSongkickRoute
  AuthBasicAddTwitterRoute: typeof AuthBasicAddTwitterRoute
  AuthBasicOnboardingRoute: typeof AuthBasicOnboardingRoute
  AuthBasicOnboarding1Route: typeof AuthBasicOnboarding1Route
  AuthBasicOnboarding2Route: typeof AuthBasicOnboarding2Route
  AuthBasicOnboarding3Route: typeof AuthBasicOnboarding3Route
}

const AuthBasicRouteChildren: AuthBasicRouteChildren = {
  AuthBasicAddAccount1Route: AuthBasicAddAccount1Route,
  AuthBasicAddAccount2Route: AuthBasicAddAccount2Route,
  AuthBasicAddAccount3Route: AuthBasicAddAccount3Route,
  AuthBasicAddAccount4Route: AuthBasicAddAccount4Route,
  AuthBasicAddAccount5Route: AuthBasicAddAccount5Route,
  AuthBasicAddAccount6Route: AuthBasicAddAccount6Route,
  AuthBasicAddAccountFinalRoute: AuthBasicAddAccountFinalRoute,
  AuthBasicAddAccountPreRoute: AuthBasicAddAccountPreRoute,
  AuthBasicAddBandsintownRoute: AuthBasicAddBandsintownRoute,
  AuthBasicAddFacebookRoute: AuthBasicAddFacebookRoute,
  AuthBasicAddInstagramRoute: AuthBasicAddInstagramRoute,
  AuthBasicAddSongkickRoute: AuthBasicAddSongkickRoute,
  AuthBasicAddTwitterRoute: AuthBasicAddTwitterRoute,
  AuthBasicOnboardingRoute: AuthBasicOnboardingRoute,
  AuthBasicOnboarding1Route: AuthBasicOnboarding1Route,
  AuthBasicOnboarding2Route: AuthBasicOnboarding2Route,
  AuthBasicOnboarding3Route: AuthBasicOnboarding3Route,
}

const AuthBasicRouteWithChildren = AuthBasicRoute._addFileChildren(
  AuthBasicRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AuthBasicRoute: AuthBasicRouteWithChildren,
  ConfirmRoute: ConfirmRoute,
  LoginRoute: LoginRoute,
  PrivacyPolicyRoute: PrivacyPolicyRoute,
  RaauthRoute: RaauthRoute,
  ResetRoute: ResetRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  ResetPasswordMessageRoute: ResetPasswordMessageRoute,
  ResetPasswordSuccessRoute: ResetPasswordSuccessRoute,
  SignUpRoute: SignUpRoute,
  SignUpContinueRoute: SignUpContinueRoute,
  TcauthRoute: TcauthRoute,
  TermsAndConditionsRoute: TermsAndConditionsRoute,
  WelcomeRoute: WelcomeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
